import { render, staticRenderFns } from "./BookingOrderList.vue?vue&type=template&id=6aa3b6b8&scoped=true"
import script from "./BookingOrderList.vue?vue&type=script&lang=js"
export * from "./BookingOrderList.vue?vue&type=script&lang=js"
import style0 from "./BookingOrderList.vue?vue&type=style&index=0&id=6aa3b6b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa3b6b8",
  null
  
)

export default component.exports